import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import { oneOf, string as stringType } from 'prop-types';
import {
  Card,
  CardTitle,
  CardContent,
  Typography
} from '@one-thd/sui-atomic-components';
import { StoreHeroDropdown } from '../store-hero-dropdown/StoreHeroDropdown';
import staticAssets from './services-static-assets';

const StoreHeroServices = ({ type, storeZip }) => {
  const titleTypography = <Typography variant="h2">{staticAssets[type]?.title}</Typography>;

  return (
    <Card
      grow
      data-component="StoreHeroServices"
      className="sui-h-full"
      CardContentProps={{ className: 'sui-flex sui-p-4 sui-gap-4 sui-flex-col sui-grow' }}
    >
      <CardTitle header={titleTypography} />
      <CardContent disablePadding disableGutters className="sui-flex sui-flex-col">
        <div>
          <img
            style={{ objectFit: 'cover', width: '100%', height: '185px' }}
            alt={staticAssets[type]?.banner.alt}
            src={staticAssets[type]?.banner.imageUrl}
            width={50}
            height={185}
          />
        </div>
        <div className="sui-mt-8">
          <img
            style={{ objectFit: 'cover', height: '50px' }}
            alt={staticAssets[type]?.logo.alt}
            src={staticAssets[type]?.logo.imageUrl}
            width="auto"
            height={50}
          />
          <div className="sui-mt-4">
            <div>
              {staticAssets[type]?.caption?.top}
            </div>
            {staticAssets[type]?.caption?.bottom
                && <div>{staticAssets[type]?.caption?.bottom}</div>}
          </div>
        </div>
        {type === 'home' && (
          <StoreHeroDropdown
            storeZip={storeZip}
          />
        )}
      </CardContent>
    </Card>
  );
};

StoreHeroServices.propTypes = {
  type: oneOf(['rental', 'home', 'garden']),
  storeZip: stringType
};

StoreHeroServices.defaultProps = {
  type: 'rental',
  storeZip: '30339'
};

StoreHeroServices.dataModel = extend(StoreHeroDropdown);

StoreHeroServices.displayName = 'StoreHeroServices';

export { StoreHeroServices };
